module.exports = __webpack_public_path__ + "img/car-ga2ceb00b8_1920.19563ee9.png";